export const TableVehicleDtoToTableVehicleListItem = (tableVehicleList) => tableVehicleList.map(dto => ({
    fleet: dto.frota,
    groupId: dto.grupoID,
    legalName: dto.razaoSocial,
    tradeName: dto.nomeFantasia,
    cnpj: dto.CNPJ,
    plate: dto.placa,
    chassis: dto.chassi,
    renavam: dto.renavam,
    fipeCode: dto.codigoFipe,
    brand: dto.marca,
    model: dto.modelo,
    version: dto.versao,
    manufacturingYear: dto.anoFabricacao,
    modelYear: dto.anoModelo,
    fuelType: dto.combustivel,
    reserveVehicle: dto.veiculoReserva,
    implementationDate: dto.dataImplantacao,
    expirationDate: dto.dataFinalVigencia,
}));
export const TableVehicleListDtoToTableVehicleList = (tableSchedule) => ({
    itens: TableVehicleDtoToTableVehicleListItem(tableSchedule.data),
    pageCount: tableSchedule.ultimaPagina,
    rows: tableSchedule.total,
});
